export default __webpack_public_path__ + "static/media/foodz@3x.dda58458.png";